import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Text,
  VStack,
  HStack,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { FiUser, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { recordActivity } from "../../utils/recordActivity";

const UserProfileMenu: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const bgMenu = useColorModeValue("white", "gray.700");

  const handleLogout = async () => {
    try {
      await recordActivity("logout", true, "Signed out");
      await logout();
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.message || "Failed to logout",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const getInitials = () => {
    if (currentUser?.displayName) {
      return currentUser.displayName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    }
    if (currentUser?.email) {
      return currentUser.email[0].toUpperCase();
    }
    return "U";
  };

  return (
    <Menu>
      <MenuButton>
        <HStack spacing={3}>
          <Avatar
            size="sm"
            name={currentUser?.displayName || currentUser?.email || "User"}
            bg="#023047"
          >
            {getInitials()}
          </Avatar>
          <VStack align="start" spacing={0} display={{ base: "none", md: "flex" }}>
            <Text fontSize="sm" fontWeight="semibold">
              {currentUser?.displayName || "Super Admin"}
            </Text>
            <Text fontSize="xs" color="gray.500">
              {currentUser?.email}
            </Text>
          </VStack>
        </HStack>
      </MenuButton>
      <MenuList bg={bgMenu} minW="200px">
        <MenuItem onClick={() => navigate("/profile")}>
          {React.createElement(FiUser as React.ComponentType<any>, { style: { marginRight: "8px", display: "inline-block" } })}
          Profile
        </MenuItem>
        <MenuItem onClick={handleLogout} color="red.500">
          {React.createElement(FiLogOut as React.ComponentType<any>, { style: { marginRight: "8px", display: "inline-block" } })}
          Logout
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default UserProfileMenu;
